'use client';

import type { AnalyticsEventParamsType } from '@repo/analytics';
import { trackEvent } from '@repo/web-chrome/lib/analytics';
import { useEffect, useRef } from 'react';

interface ITrackViewOnMountProps {
  event: string;
  params?: AnalyticsEventParamsType;
}

export function TrackViewOnMount({ event, params }: ITrackViewOnMountProps): null {
  const sentRef = useRef(false);

  useEffect(() => {
    if (sentRef.current) {
      return;
    }
    sentRef.current = true;
    trackEvent(event, params);
  }, [event, params]);

  return null;
}
